import { render, staticRenderFns } from "./CoModal.vue?vue&type=template&id=66b0eb94&scoped=true&"
import script from "./CoModal.vue?vue&type=script&lang=ts&"
export * from "./CoModal.vue?vue&type=script&lang=ts&"
import style0 from "./CoModal.vue?vue&type=style&index=0&id=66b0eb94&prod&lang=less&"
import style1 from "./CoModal.vue?vue&type=style&index=1&id=66b0eb94&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b0eb94",
  null
  
)

export default component.exports